import { defineComponent } from 'vue'

import './appbar.scss'
import { keycloakInit } from '@/services/api';
import { i18n } from '@/app-i18n';




export default defineComponent({
    props: {
        title: String,
        back: String,
        defaultTitle: { type: Boolean, default: false },
    },

    data() {
        return {
            displayTitle: "",
            lang: "en",
            usernamelogin: "",
            greet: i18n.global.t("message.hello")

        };
    },


    mounted: async function () {
        this.displayTitle=this.title;
        if (this.defaultTitle) {
            try {
                await keycloakInit.catch(console.error);
            } catch (error) {
                console.error(error);
            }

            this.usernamelogin = sessionStorage.getItem("USERNAME");

            this.displayTitle = `${this.greet} <strong>${this.usernamelogin}</strong>`;
           
        }
    },
    methods: {

    },
    watch: {
        title(newTitle) {
            if (this.defaultTitle) {
            } else {
                this.displayTitle = newTitle;
            }
        }
    }
})